<template>
  <button
    class="base-btn"
    :class="createCellStyle"
    @click="store.findingCell=true;store.P5Instance.addBlob()"
  >
    Create Cell
  </button>
</template>
<script>
import { store } from "../../store";

export default {
  name: "CreateCellButton",
  data: () => ({ store }),
  computed: {
    createCellStyle() {
      return {
        "disabled-btn": !store.color2,
        "solid-active-blue-btn": store.color2,
      };
    },
  },
};
</script>